import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── Google Translate ⇄ React crash guard ───────────────────────────
// Google Translate rewrites text nodes in-place. When React later tries to
// remove/insert around those swapped nodes it throws NotFoundError on
// removeChild/insertBefore and the whole app white-screens. Making these two
// DOM ops no-op when the node isn't actually a child keeps React and
// Translate coexisting (users can translate the page without errors).
if (typeof Node === "function" && Node.prototype) {
  const _removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return _removeChild.apply(this, arguments);
  };
  const _insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return _insertBefore.apply(this, arguments);
  };
  const _replaceChild = Node.prototype.replaceChild;
  Node.prototype.replaceChild = function (newNode, oldNode) {
    if (oldNode && oldNode.parentNode !== this) {
      return oldNode;
    }
    return _replaceChild.apply(this, arguments);
  };
}

// Suppress the benign ResizeObserver loop warning that shadcn Tabs/Select
// emit during fast interactions. Without this, webpack-dev-server's error
// overlay intercepts Playwright clicks in E2E tests.
const RO_MSG = "ResizeObserver loop";
const stopRO = (e) => {
  if (e?.message?.includes?.(RO_MSG) || e?.reason?.message?.includes?.(RO_MSG)) {
    e.stopImmediatePropagation?.();
  }
};
window.addEventListener("error", stopRO);
window.addEventListener("unhandledrejection", stopRO);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
